import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from './checkbox';
import RadioGroup from './radio_group';

function Newsletter(props) {
  return (
    <div className="newsletter">
      <h4 className="newsletter__name">{props.name}</h4>
      <p className="newsletter__desc">{props.desc}</p>

      {props.isRadio ? (
        <RadioGroup
          listIds={props.lists}
          onChange={props.handleNewslettersRadioUpdate}
          choices={props.choices}
          checked={props.checked}
        />
      ) : (
        props.lists.map(function generateListsOptions(listId, index) {
          return (
            <Checkbox
              listId={listId}
              onChange={props.onChange}
              checked={props.checked[index]}
              choice={props.choices[index]}
              key={listId}
            />
          );
        })
      )}
    </div>
  );
}

Newsletter.defaultProps = {
  choices: [],
  isRadio: false,
  handleNewslettersRadioUpdate: () => {}
};

Newsletter.propTypes = {
  name: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  lists: PropTypes.arrayOf(PropTypes.number).isRequired,
  choices: PropTypes.arrayOf(PropTypes.string),
  checked: PropTypes.arrayOf(PropTypes.bool).isRequired,
  onChange: PropTypes.func.isRequired,
  handleNewslettersRadioUpdate: PropTypes.func,
  isRadio: PropTypes.bool
};

export default Newsletter;
